import React, { useEffect, useState } from 'react';
import FileUpload from './FileUpload/FileUpload';

const ServiceDetails = ({ onDataChange, initialValues = {} }) => {
    const [name, setName] = useState(initialValues.name || '');
    const [description, setDescription] = useState(initialValues.description || '');
    const [price, setPrice] = useState(initialValues.price || '');
    const [hours, setHours] = useState(initialValues.hours || '');
    const [minutes, setMinutes] = useState(initialValues.minutes || '');

    useEffect(() => {
        setName(initialValues.name || '');
        setDescription(initialValues.description || '');
        setPrice(initialValues.price || '');
        const durationParts = (initialValues.duration || '').split(' ');
        const parsedHours = durationParts[0] || '';
        const parsedMinutes = durationParts[2] || '';
        setHours(parsedHours);
        setMinutes(parsedMinutes);
    }, [initialValues]);

    const handleNameChange = (e) => {
        setName(e.target.value);
        notifyParent();
    };

    const handleDescriptionChange = (e) => {
        setDescription(e.target.value);
        notifyParent();
    };

    const handlePriceChange = (e) => {
        setPrice(e.target.value);
        notifyParent();
    };

    const handleHoursChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) { // Allow only non-negative numbers
            setHours(value);
            notifyParent();
        }
    };

    const handleMinutesChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) { // Allow only non-negative numbers
            setMinutes(value);
            notifyParent();
        }
    };

    const notifyParent = () => {
        const duration = `${hours} hours ${minutes} minutes`;
        onDataChange({ name, description, price, duration });
    };

    return (
        <div>
            <h3>Service Details</h3>
            <input
                type="text"
                placeholder="Service Name"
                value={name}
                onChange={handleNameChange}
            />
            <textarea
                placeholder="Service Description"
                value={description}
                onChange={handleDescriptionChange}
            ></textarea>
            <input
                type="number"
                placeholder="Price"
                value={price}
                onChange={handlePriceChange}
                min="0" // Ensure price cannot be negative
            />
            <div>
                <input
                    type="number"
                    placeholder="Hours"
                    value={hours}
                    onChange={handleHoursChange}
                    min="0" // Ensure hours cannot be negative
                />
                <input
                    type="number"
                    placeholder="Minutes"
                    value={minutes}
                    onChange={handleMinutesChange}
                    min="0" // Ensure minutes cannot be negative
                />
            </div>
            <FileUpload
                label="Choose Files"
            />
        </div>
    );
};

export default ServiceDetails;
